
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useRfmGroupList } from '@/modules/rfm/group/model/list';
import { color } from '@/common/utils/helpers';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_RFM.GROUP.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchRfmGroupAll, actions } = useRfmGroupList();

        const table: TableConfig = {
            columns: [
                {
                    type: TableColumnType.Html,
                    label: 'Name',
                    htmlHandler(row: any) {
                        return `<font color="${color(row.id)}"><i class="fas fa-bookmark"></i></font> ${row.name}`;
                    }
                },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_RFM.GROUP.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-calendar-alt',
                        theme: 'success',
                        tooltip: 'Show recencies',
                        to: { name: ROUTE_NAME_RFM.RECENCY.INDEX, query: { groupId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-file-invoice-dollar',
                        theme: 'success',
                        tooltip: 'Show frequencies',
                        to: { name: ROUTE_NAME_RFM.FREQUENCY.INDEX, query: { groupId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-dollar-sign',
                        theme: 'success',
                        tooltip: 'Show monetaries',
                        to: { name: ROUTE_NAME_RFM.MONETARY.INDEX, query: { groupId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-users-cog',
                        theme: 'primary',
                        tooltip: 'Show personas',
                        to: { name: ROUTE_NAME_RFM.PERSONA.INDEX, query: { groupId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-sliders-h',
                        theme: 'warning',
                        tooltip: 'Show segmentation',
                        to: { name: ROUTE_NAME_RFM.SEGMENTATION, query: { groupId: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    }),
                    group: 2
                }
            ]
        };

        onMounted(fetchRfmGroupAll);

        return { table, list, total, fetchRfmGroupAll, ROUTE_NAME_RFM };
    }
});
